import React from 'react';
import PropTypes from 'prop-types';

import documentTypeService from '../../../services/documentType/DocumentTypeService';
import {FIELD_CODE, FIELD_OPTION} from '../../../utils/constant';

import EditAdditionalDesignationModal from './EditAdditionalDesignationModal';
import {captureError} from '../../../utils/log';

function EditAdditionalDesignationModalContainer(props) {
  const [isRequired, setIsRequired] = React.useState();

  React.useEffect(() => {
    const typeCode = props.document?.type?.code;
    if (typeCode) {
      documentTypeService.getMetadataFields(typeCode)
        .then(res => {
          const field = res.find(f => f.fieldCode === FIELD_CODE.ADDITIONAL_DESIGNATION);
          setIsRequired(field?.fieldOption === FIELD_OPTION.REQUIRED);
        })
        .catch(error => {
          captureError(`Error getting metadata fields using documentTypeService.getMetadataFields with code ${typeCode} : `, error);
          setIsRequired(true);
        });
    }
  }, [props.document?.type?.code]);

  if (isRequired === undefined) { return null; }

  return (
    <EditAdditionalDesignationModal
      {...props}
      isRequired={isRequired}
    />
  );
}

EditAdditionalDesignationModalContainer.propTypes = {
  document: PropTypes.object.isRequired
};

export default EditAdditionalDesignationModalContainer;
